import styled from "styled-components";

export const ChatSection = styled.section`
  width: 100%;
  max-width: 56rem;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--hr-color);
`;

export const ChatTitle = styled.h2`
  margin: 0 0 1rem;
`;

export const ChatHistory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const ChatMessageRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const ChatMessageActions = styled.div`
  display: flex;
  flex: 0 0 2.75rem;
  justify-content: center;
`;

export const ChatMessageCard = styled.article`
  flex: 1;
  min-width: 0;
  padding: 1rem;
  border: 1px solid var(--hr-color);
  border-radius: 5px;
  background: var(--panel-bg);
`;

export const ChatMessageMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
  color: var(--text-color);
`;

export const ChatRecipients = styled.div`
  margin-bottom: 0.5rem;
  color: var(--text-color);
  font-size: 0.8rem;
  font-style: italic;
`;

export const ChatMessageText = styled.div`
  white-space: pre-wrap;
  color: var(--text-color);
`;
